<div class="container-fluid">
    <div class="row top10 no-gutters">
        <div class="col-xs-12 col-md-6 vcenter">
            <h4>Edit States/Territories</h4>
        </div>
        <div class="col-xs-12 col-md-6  vcenter-right">
            <div>
            </div>
        </div>
    </div>

    <hr style="margin-top:2px;margin-bottom:2px" />


    <aims-common-table
        id="config-states-table"
        [dataSource]="states | async"
        [header]="header"
        [pageSize]="10"
        [permissions]="tablePermissions"
        [addRowInitialObject]="initialTableElement"
        (rowUpdated)="handleRowUpdate($event)"
        (rowAdded)="handleRowAdd($event)"
        >

    </aims-common-table>
</div>